(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  const detailsSelector = 'body > footer > .shopify-section:has(.footer-menu-m) .footer-menu-m .menu__details';

  const syncFooterMenus = () => {
    document.querySelectorAll(detailsSelector).forEach((details) => {
      if (!(details instanceof HTMLDetailsElement)) return;

      if (details.dataset.figmaFooterForcedOpen === 'true') {
        details.removeAttribute('open');
        delete details.dataset.figmaFooterForcedOpen;
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFooterMenus, { once: true });
  } else {
    syncFooterMenus();
  }

  mobileQuery.addEventListener('change', syncFooterMenus);
  document.addEventListener('shopify:section:load', syncFooterMenus);
})();
